<app-breadcrumb [root]="breadcrumb.root" [whereThis]="breadcrumb.whereThis" append="Valor"></app-breadcrumb>
<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="container">
    <div fxLayout="row" fxLayoutGap="20px" *ngIf="f.name.enabled">
      <div fxFlex="45">
        <mat-form-field class="ps-input" appearance="fill">
          <mat-label>Atributo</mat-label>
          <input matInput formControlName="name" required>
          <mat-error *ngIf="f.name.hasError('required')">
            Campo obrigatório
          </mat-error>
          <mat-error *ngIf="f.name.hasError('keyAlreadyExists')">
            Esse nome já está sendo utilizado
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="send-value" fxLayout="row">
      <div>
        <label>Valor enviado</label>
        <mat-radio-group aria-label="Valor enviado" formControlName="value_type" class="radio-group">
          <mat-radio-button class="radio-button" value="1" color="primary">Campo do sistema</mat-radio-button>
          <mat-radio-button class="radio-button" value="2" color="primary">Valor fixo</mat-radio-button>
        </mat-radio-group>
      </div>
      <div fxFlex>
        <mat-form-field class="ps-input" appearance="fill" *ngIf="f.value_type.value == 1">
          <mat-label>Campo do sistema</mat-label>
          <input type="text" matInput formControlName="value" [matAutocomplete]="autoRegister" required>
          <mat-autocomplete #autoRegister="matAutocomplete" [displayWith]="displayField">
            <mat-option *ngFor="let option of fieldsAutoComplete | async; let i = index" [value]="option">
              {{option.label}}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="f.value.hasError('required')">
            Campo obrigatório
          </mat-error>
          <mat-error *ngIf="f.value.hasError('unselectedField') && !f.value.hasError('required')">
            Selecione um campo do sistema
          </mat-error>
        </mat-form-field>
        <mat-form-field class="ps-input" appearance="fill" *ngIf="f.value_type.value != 1">
          <mat-label>Valor</mat-label>
          <input matInput formControlName="value" required>
          <mat-error *ngIf="f.value.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <app-save-dialog [form]="form"></app-save-dialog>
  </div>
</form>
